listFieldsDirective = angular.module('listfields.setting', [])

listFieldsDirective.directive "listFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "Widget", "blockEditDialog", "ContentEditable", ($window, $timeout, $compile, $templateCache, ns, translitService, Widget, blockEditDialog, ContentEditable) ->
  restrict: "A",
  scope: {data: "=ngModel", afterRowCreate: "&afterRowCreate"},
  templateUrl: "#{settingFolder}/listfields/template.jade"
  link: (scope, element, attrs, ngModel) ->
    id = attrs.widgetId
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass
    scope.list = angular.copy scope.data
    sectionId = blockEditDialog.getSectionId id:id
    widgetElWrapper.find("a").click (e) ->
      e.preventDefault()
    getNotDestroyedFieldRnd = ->
      fields = []
      _.each scope.list.rows_attributes, (field, index) ->
        if !field._destroy
          fields.push index
      if fields.length > 0
        fields[fields.length-1]
      else
        0

    scope.currentField = getNotDestroyedFieldRnd()

    sortItems = ->
      product_items_ids = []
      for row, index in scope.list.rows_attributes
        row.position = index

    trimNbsp = (fields) ->
      for field in fields
        field.caption = field.caption.replace(/&nbsp;/gi,'')
      fields
    scope.fieldsLength = (fields) ->
      destroyed = _.filter fields, _destroy: true
      fields.length - destroyed.length
    scope.setCurrentImage = ($index) ->
      scope.currentField = $index
    afterCreate = (data) ->
      newRow = data.rows_attributes[data.rows_attributes.length-1]
      scope.list.rows_attributes.push newRow
      length = scope.list.rows_attributes.length
      newRowHTML = "<li data-item-id='#{newRow.id}' style='background-image: url(#{scope.data.image_attributes.source_url})'><span class='strbw_list-item__caption' contenteditable='false' data-access='rows_attributes.#{length-1}.caption'>#{newRow.caption}</span></li>"
      widgetElWrapper.find(".strbw_list").append newRowHTML
      scope.setCurrentImage length - 1
      ContentEditable.bind false, true, id
      sortItems()
    afterProductItemRowCreate = (data) ->
      newRow = data.rows_attributes[data.rows_attributes.length-1]
      scope.list.rows_attributes.push newRow
      scope.afterRowCreate()
      return
    scope.add = ->
      sectionId = blockEditDialog.getSectionId id:id
      params =
        rows_attributes: [{
          is_temp: true
        }]
      if attrs.fromProduct
        Widget.createProductItemRow(attrs.productId, attrs.productItemId, params).then afterProductItemRowCreate
      else
        Widget.createItem(sectionId, id, params).then afterCreate
    removeCurrentImage = ->
      imageId = scope.list.rows_attributes[scope.currentField].id
      index = $("[data-item-id='#{imageId}']").remove()
    scope.remove = ->
      scope.list.rows_attributes[scope.currentField]._destroy = true
      removeCurrentImage()
      scope.setCurrentImage getNotDestroyedFieldRnd()
      sortItems()
    listener1 = scope.$watch "list.rows_attributes", (newVal, oldVal) ->
      scope.data.rows_attributes = trimNbsp newVal
    , true
    listener2 = scope.$watch "data", (newVal, oldVal) ->
      return
    , true

    scope.$on "$destroy", ->
      listener1()
      listener2()
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/listfields/listfields.directive.coffee